"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSalesForceOrderResponseToJSON = exports.GetSalesForceOrderResponseFromJSONTyped = exports.GetSalesForceOrderResponseFromJSON = exports.instanceOfGetSalesForceOrderResponse = void 0;
var runtime_1 = require("../runtime");
var FulfillmentItem_1 = require("./FulfillmentItem");
var SalesOrder_1 = require("./SalesOrder");
/**
 * Check if a given object implements the GetSalesForceOrderResponse interface.
 */
function instanceOfGetSalesForceOrderResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetSalesForceOrderResponse = instanceOfGetSalesForceOrderResponse;
function GetSalesForceOrderResponseFromJSON(json) {
    return GetSalesForceOrderResponseFromJSONTyped(json, false);
}
exports.GetSalesForceOrderResponseFromJSON = GetSalesForceOrderResponseFromJSON;
function GetSalesForceOrderResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'salesOrder': !(0, runtime_1.exists)(json, 'salesOrder') ? undefined : (0, SalesOrder_1.SalesOrderFromJSON)(json['salesOrder']),
        'sasFulfillmentItems': !(0, runtime_1.exists)(json, 'sasFulfillmentItems') ? undefined : (json['sasFulfillmentItems'].map(FulfillmentItem_1.FulfillmentItemFromJSON)),
    };
}
exports.GetSalesForceOrderResponseFromJSONTyped = GetSalesForceOrderResponseFromJSONTyped;
function GetSalesForceOrderResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'salesOrder': (0, SalesOrder_1.SalesOrderToJSON)(value.salesOrder),
        'sasFulfillmentItems': value.sasFulfillmentItems === undefined ? undefined : (value.sasFulfillmentItems.map(FulfillmentItem_1.FulfillmentItemToJSON)),
    };
}
exports.GetSalesForceOrderResponseToJSON = GetSalesForceOrderResponseToJSON;
